import { SvgIcon } from "@mui/material";

export default function WithdrawIcon({ ...restProps }) {
  return (
    <SvgIcon
      {...restProps}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.27786 1.3335C6.57169 1.3335 4.86598 1.98495 3.56432 3.28662C0.960983 5.88995 0.960983 10.1104 3.56432 12.7137C6.16765 15.317 10.3881 15.317 12.9914 12.7137C15.5947 10.1104 15.5947 5.88995 12.9914 3.28662C11.6897 1.98495 9.98403 1.3335 8.27786 1.3335ZM8.27786 2.66683C9.64286 2.66683 11.0074 3.188 12.0487 4.22933C14.1314 6.312 14.1314 9.68833 12.0487 11.771C9.96603 13.8537 6.58969 13.8537 4.50702 11.771C2.42436 9.68833 2.42436 6.312 4.50702 4.22933C5.54836 3.188 6.91286 2.66683 8.27786 2.66683ZM6.27786 5.3335V6.66683H8.66848L5.61119 9.72412L6.5539 10.6668L9.61119 7.60954V10.0002H10.9445V5.3335H6.27786Z"
        fill="white"
      />
    </SvgIcon>
  );
}
